import React from 'react';
import { Box } from '@mui/material';

const GovtStrip = () => {
  return (
    <Box sx={{ height: 140, display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#fff', color: 'black', gap: '1rem', padding: '0 1.5rem' }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <img src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg" alt="image2" style={{ height: 70, margin: '10px 16px 10px 0'}} />
        <div style={{display: 'flex', color: '#1F4A7C', width: '590px', border: '7px solid #1F4A7C', position:'relative', justifyContent: 'space-between'}}>
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <h4 style={{margin: 10, padding: '0 10px', whiteSpace: 'nowrap', position: 'absolute', top: '-20px', backgroundColor: 'white'}}>उत्तर प्रदेश सरकार</h4>
            <h2 style={{color: '#154773', fontSize: '1.25rem', margin: '14px 10px 5px'}}>आवास एवं विकास परिषद</h2>
            <h2 style={{fontSize: '1.5rem', margin: '0px 0px 14px 10px'}}>Awas Evam Vikas Parishad</h2>
            <h6 style={{color: '#154773', margin: 10, padding: '0 10px', position: 'absolute', bottom:'-23px', right: 0, whiteSpace: 'nowrap', backgroundColor: 'white'}}>Government of Uttar Pradesh</h6>
          </div>
          <div>
            <img src='https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg' alt='Himachal' style={{height: '70px', margin: '10px 10px 10px 10px'}}/>
          </div>
          </div>
        </Box>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <img src='https://i.imgur.com/TmeY0xa.jpeg' alt='imageAmrit' style={{ height: 70 }} />
        <img src="https://i.imgur.com/ERyQTFC.png" alt="imageSwatchh" style={{ height: 70 }} />
        <img src='https://i.imgur.com/L8ZRv8Y.png' alt='image150' style={{ height: 70 }} />
        <img src="https://static.mygov.in/archive/g20/images/g20-logo.png" alt="imageG20" style={{ height: 70 }} />
      </div>
    </Box>
  );
};

export default GovtStrip;